var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70038 19.4951C3.13932 19.4951 2.66012 19.2964 2.26277 18.8991C1.8654 18.5017 1.66672 18.0225 1.66672 17.4615V3.18265H0.541718V1.49517H5.60419V0.5H12.3542V1.49517H17.4167V3.18265H16.2917V17.4615C16.2917 18.0297 16.0948 18.5107 15.701 18.9045C15.3073 19.2982 14.8263 19.4951 14.258 19.4951H3.70038ZM14.6042 3.18265H3.35419V17.4615C3.35419 17.5624 3.38665 17.6454 3.45156 17.7103C3.51647 17.7752 3.59941 17.8076 3.70038 17.8076H14.258C14.3445 17.8076 14.4239 17.7716 14.496 17.6995C14.5681 17.6273 14.6042 17.548 14.6042 17.4615V3.18265ZM6.05855 15.5576H7.74602V5.43265H6.05855V15.5576ZM10.2124 15.5576H11.8998V5.43265H10.2124V15.5576Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.68c419c2d88d9eeb7d7d0065a925fd96.svg";
export { ForwardRef as ReactComponent };